import { Link } from "react-router-dom";
import clsx from "clsx";
import ScaleOnHoverDiv from "../ScaleOnHoverDiv";

export const Button = ({
    children,
    to,
    className,
    onClick,
    type,
    disabled = false,
    newWindow = false,
    primary = true,
    tertiary = false,
}) => {
    let styles = `${className} ${disabled ? disabledStyle : enabledStyle}`; //primary

    if (!primary) {
        // secondary
        styles = `${className} ${disabled ? disabledStyle : secondaryStyle}`;
    }

    if (tertiary) {
        // tertiary
        styles = `${className} ${disabled ? disabledStyle : tertiaryStyle}`;
    }

    const handleKeyDown = (e) => {
        // Accesibility to mimic button but maintain animation styles
        if (e.key === "Enter" || e.key === " ") {
            onClick(e);
        }
    };

    const handleLinkClick = (e) => {
        // If onClick is provided, prevent default navigation and call onClick
        if (onClick) {
            e.preventDefault();
            onClick(e);
        }
    };

    return !disabled ? (
        <Link
            to={to}
            target={newWindow ? "_blank" : "_self"}
            onKeyDown={handleKeyDown}
            onClick={handleLinkClick}
            className="focus:scale-[0.95] focus:outline-none"
        >
            <ScaleOnHoverDiv role="button" className={styles} onClick={onClick}>
                {children}
            </ScaleOnHoverDiv>
        </Link>
    ) : (
        <div className={styles}>{children}</div>
    );
};

const style = clsx(
    "uppercase text-md tracking-widest font-bold py-3 text-center rounded-full",
);
const secondaryStyle = clsx(style + " bg-black text-[white]");
const tertiaryStyle = clsx(style + " text-black border-2");
const enabledStyle = clsx(style + " bg-green text-black");
const disabledStyle = clsx(style + " text-mediumGray bg-black/10");
